import { defineComponent as u, inject as a, reactive as C, toRefs as E, provide as i, createVNode as k, mergeProps as _, isVNode as N } from "vue";
import r from "./index592.js";
import g from "./index731.js";
import I from "./index732.js";
import x from "./index733.js";
import h from "./index734.js";
import v from "./index735.js";
import S from "./index736.js";
import T from "./index737.js";
import j from "./index738.js";
import { datePickerPanelProps as K } from "./index633.js";
import { ROOT_PICKER_INJECTION_KEY as R } from "./index632.js";
import { getPanel as Y } from "./index739.js";
import { useCommonPicker as y } from "./index580.js";
import { PICKER_BASE_INJECTION_KEY as m, ROOT_COMMON_PICKER_INJECTION_KEY as D } from "./index579.js";
import { UPDATE_MODEL_EVENT as V } from "./index584.js";
import { useNamespace as b } from "./index559.js";
import { isUndefined as A } from "./index565.js";
import J from "./index740.js";
function M(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Object]" && !N(e);
}
r.extend(x);
r.extend(I);
r.extend(g);
r.extend(h);
r.extend(v);
r.extend(S);
r.extend(T);
r.extend(j);
var ae = /* @__PURE__ */ u({
  name: "ElDatePickerPanel",
  install: null,
  inheritAttrs: !1,
  props: K,
  emits: [V, "calendar-change", "panel-change", "visible-change", "clear"],
  setup(e, {
    slots: o,
    emit: n,
    attrs: p
  }) {
    const c = b("picker-panel"), f = a(m, void 0);
    if (A(f)) {
      const t = C({
        ...E(e)
      });
      i(m, {
        props: t
      });
    }
    i(R, {
      slots: o,
      pickerNs: c
    });
    const {
      parsedValue: l,
      onCalendarChange: d,
      onPanelChange: s,
      onSetPickerOption: P,
      onPick: O
    } = a(D, () => y(e, n), !0);
    return () => {
      const t = Y(e.type);
      return k(t, _(J(p, "onPick"), e, {
        parsedValue: l.value,
        "onSet-picker-option": P,
        "onCalendar-change": d,
        "onPanel-change": s,
        onClear: () => n("clear"),
        onPick: O
      }), M(o) ? o : {
        default: () => [o]
      });
    };
  }
});
export {
  ae as default
};
